import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import validator from '../../../utils/validator';


function ConfirmationDialog(props) {
  const [open, setOpen] = React.useState(true);

  const handleClose = confirm => () => {
    setOpen(false);
    props.onClose(confirm);
  };

  return (
    <div>
      <Dialog className={`ConfirmationDialog ${props.className}`} open={open} onClose={handleClose}>
        <DialogTitle className="title">Please Confirm</DialogTitle>
        <DialogContent>
          { props.message &&
            <DialogContentText className="content">
              {props.message}
            </DialogContentText>
          }
          { validator.isEmpty(props.message) &&
            <div className="content">
              {props.children}
            </div>
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose(true)} color="default" disabled={props.disabled}>
            Continue
          </Button>
          <Button onClick={handleClose(false)} color="secondary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

ConfirmationDialog.defaultProps = {
  disabled: false,
  className: ''
};

ConfirmationDialog.propTypes = {
  message: PropTypes.string,
  onClose: PropTypes.func
};

export default ConfirmationDialog;